module.exports = __webpack_public_path__ + "Lato-Hairline.482fe0a9e92d9c5ff7fe.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Hairline.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Hairline.woff
// module chunks = styles